<script>
export default {
  name: "TableAnnidata",
  props: {
    row: {
      required: true,
      type: Object,
    }
  }
}
</script>

<template>
    <div class="d-flex align-items-center justify-content-center">
      <!-- bottone visibile solo se l'item ha figli -->
      <span>{{ row.item.wpw_id }}</span>
      <b-button
          v-if="row.item.wpw_id_piano_padre"
          size="sm"
          variant="link"
          @click="row.toggleDetails"
      >
        {{ row.detailsShowing ? '▲' : '▼ ' + row.item.wpw_id_piano_padre }}
      </b-button>
    </div>
</template>

<style scoped>

</style>